<section class="pt-2">
    <div class="container-style">
        <div class="row align-items-center pb-2">
            <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                <h6> {{ isFormView ? 'Registrar despiece del artículo compuesto' : 'Despiece del artículo compuesto' }}
                </h6>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
                <div class="d-flex">
                    <app-custom-button [label]="'Nuevo despiece'" [severity]="'success'" [width]="'7.5rem'"
                        [disabled]="!permissionUpdatable" (onClick)="openArticleSelectionModal()"></app-custom-button>
                    <app-custom-modal #articleSelection [label]="'Seleccionar'"
                        [header]="'Selección de artículos para el despiece'" [children]="componentTableSelection"
                        [inputs$]="inputsForArticlesSelection$" [output$]="output$"
                        (selectedItems)="handleSelectedItem($event)" hidden>
                    </app-custom-modal>
                </div>
            </div>
        </div>
        <div class="row mx-0" [hidden]="!isFormView">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
                <app-register-composite-article-detail [compositeArticleDetails]="compositeArticleDetails"
                    [compositeArticleModel]="compositeArticleModel"
                    [compositeArticleDetailContract]="compositeArticleDetail" (isFormView)="getFormView($event)"
                    (updateListDetail)="getCompositeArticleDetailsForCapture()">
                </app-register-composite-article-detail>
            </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
            <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
                [showCheckbox]="permissionUpdatable" [checkBoxAction]="checkboxActions"
                [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getCompositeArticleDetailsForCapture()"
                (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
            </app-custom-table>
        </div>
    </div>
</section>